import { Box, Chip, Container, Stack, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PoolInstance, isInstance } from '@synergy/config';
import { PoolRow, PoolTooltip, PoolTypography, useIsMobile } from '@synergy/components-next';
import { QuestionMarkOutlineIcon } from '@synergy/theme-next';
import { ReactElement, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { ChipButton } from '../../../components/chip-button/chip-button';
import { Filter, FilterSearch } from '../../../components/filter';
import { supplierDirectoryDataSelector } from '../../../store/supplier-selectors';
import { useAppSelector } from '../../../../store/store';

const StyledBox = styled(Box)(({ theme }) => ({
    width: '100%',
    backgroundColor: theme.palette.grey[100],
}));

export const SupplierDirectorySearchBar = (): ReactElement => {
    const [searchParams, setSearchParams] = useSearchParams();
    const { total } = useAppSelector(supplierDirectoryDataSelector);
    const isMobile = useIsMobile();
    const [tooltipOpen, setTooltipOpen] = useState(false);

    return (
        <Filter searchParams={searchParams} updateSearch={setSearchParams}>
            <StyledBox>
                <Container maxWidth="xl" sx={{ py: { xs: 2, sm: 6 } }}>
                    <Stack
                        gap={1}
                        direction={isMobile ? 'column' : 'row'}
                        justifyContent="space-between"
                        alignItems={isMobile ? 'normal' : 'end'}
                        sx={{ height: '100%', width: '1005' }}
                    >
                        <Stack gap={2} sx={{ width: '100%', maxWidth: isMobile ? '100%' : '50%' }}>
                            <PoolTypography variant="h5" translationId="app.supplierDirectory.subTitle" />
                            <FilterSearch fullWidth={true} />
                        </Stack>

                        {isInstance(PoolInstance.CH) && (
                            <PoolRow>
                                <PoolTooltip
                                    open={tooltipOpen}
                                    onClose={() => setTooltipOpen(false)}
                                    disableHoverListener
                                    variant="light"
                                    placement="bottom"
                                    title={
                                        <Stack gap={2}>
                                            <PoolTypography variant="body1">
                                                <strong>
                                                    <FormattedMessage id="app.supplierDirectory.infoTooltip" />
                                                </strong>
                                            </PoolTypography>
                                            <PoolTypography variant="body2">
                                                <strong>
                                                    <FormattedMessage id="app.supplierDirectory.infoTooltip.bonus" />
                                                </strong>
                                                <br />
                                                <FormattedMessage id="app.supplierDirectory.infoTooltip.bonus.text" />
                                                <br />
                                                <br />
                                                <strong>
                                                    <FormattedMessage id="app.supplierDirectory.infoTooltip.contract" />
                                                </strong>
                                                <br />
                                                <FormattedMessage id="app.supplierDirectory.infoTooltip.contract.text" />
                                            </PoolTypography>
                                        </Stack>
                                    }
                                >
                                    <ChipButton
                                        variant="outlined"
                                        color={'dark'}
                                        startIcon={<QuestionMarkOutlineIcon />}
                                        onClick={() => setTooltipOpen(!tooltipOpen)}
                                    >
                                        <FormattedMessage id="app.supplierDirectory.infoTooltip" />
                                    </ChipButton>
                                </PoolTooltip>
                                <Chip
                                    variant="outlined"
                                    label={<FormattedMessage id="app.supplierDirectory.total" values={{ total }} />}
                                    disabled={true}
                                />
                            </PoolRow>
                        )}
                    </Stack>
                </Container>
            </StyledBox>
        </Filter>
    );
};
